module.exports = __webpack_public_path__ + "static/sol-section-1-img-b9e154b52ced9843471564ea36e768b2.png";